const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_authenticated-user/superuser/afpant/$orgNumber/intensjonsmelding/$intentionMessageId/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { routeLoaderApiClient } from "@/lib/api";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_authenticated-user/superuser/afpant/$orgNumber/intensjonsmelding/$intentionMessageId/")({
  loader: async ({
    params
  }) => {
    const {
      orgNumber,
      intentionMessageId
    } = params;
    const res = await routeLoaderApiClient.superuser.afpant[":orgNumber"]["intention-message"][":intentionMessageId"].$get({
      param: {
        orgNumber,
        intentionMessageId
      }
    });
    if (res.ok === false) {
      throw new Error("Failed to fetch intention message");
    }
    return {
      message: await res.json()
    };
  },
  head: () => ({
    meta: [{
      title: "Intensjonsmelding | Alice & Bob"
    }]
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});